// extracted by mini-css-extract-plugin
export default {"app":"app_f6a50db18912f02735e3"};